import { Desktop, Mobile } from '../../../components/media'

const COLUMNS = 2

export default function Features({ features }) {
  const rows = [...Array(Math.ceil(features.length / COLUMNS))]
  const featuresRows = rows.map((_, index) =>
    features.slice(index * COLUMNS, index * COLUMNS + COLUMNS),
  )

  return (
    <>
      <div className='wrapper'>
        <Desktop>
          {featuresRows.map((row, index) => (
            <div className='line flex justifyBetween' key={index}>
              {row.map((feat) => (
                <div className='item flex' key={feat.title}>
                  <div className='title'>{feat.title}</div>
                  <div className='value'>{feat.value}</div>
                </div>
              ))}
            </div>
          ))}
        </Desktop>
        <Mobile>
          {features.map((feat) => {
            return (
              <div className='line flex justifyBetween' key={feat.title}>
                <div className='item flex'>
                  <div className='title'>{feat.title}</div>
                  <div className='value'>{feat.value}</div>
                </div>
              </div>
            )
          })}
        </Mobile>
      </div>

      <style jsx>{`
        .wrapper {
          width: 100%;
        }

        .line {
          width: 100%;
          padding: 1.95rem 0 3.65rem;
          border-bottom: 1px solid var(--secondary-input-bg);

          &.line:last-child {
            border-bottom: 0;
          }
        }

        .item {
          flex: 1;
        }

        .title {
          min-width: 19.5rem;
          color: var(--secondary-text-color);
          font-size: 1.8rem;
          line-height: 2.4rem;
        }

        .value {
          padding: 0 0.5rem 0 0;
          word-break: break-all;
          font-size: 1.8rem;
          font-weight: 700;
          line-height: 2.4rem;
        }

        @media (min-width: 1025px) and (max-width: 1364px) {
          .title,
          .value {
            line-height: 1.9rem;
            font-size: 1.4rem;
          }

          .title {
            min-width: 11.1rem;
            max-width: 11.1rem;
          }

          .line {
            padding: 1.85rem 0 1.45rem;
          }
        }

        @media (max-width: 1024px) {
          .title,
          .value {
            min-width: 50%;
            font-size: 1.4rem;
            line-height: 1.9rem;
          }

          .line {
            padding: 1.45rem 0 1.65rem;
          }
        }
      `}</style>
    </>
  )
}
